import PropTypes from "prop-types";
import React from "react";

// Upload-session status buckets → coloured dots (mirrors the legacy dashboard).
const BUCKETS = [
  { key: "progress", label: "In progress", color: "#f3a64a", statuses: [0, 1] },
  { key: "partial", label: "Partial", color: "#ffcb3d", statuses: [4] },
  { key: "completed", label: "Completed", color: "#cdd3d6", statuses: [2] },
  { key: "synced", label: "Synchronized", color: "#56c596", statuses: [3] },
];

// `counts` is the per-entity status map from the summary endpoint:
// { "0": n, "1": n, ..., total: n }. Renders a cloud icon + one dot per bucket.
export const UploadCounter = ({ counts, onSelect }) => {
  const total = counts?.total ?? 0;

  if (total === 0)
    return (
      <span className="cf-uploads is-empty" title="No upload session">
        <i className="fa-solid fa-cloud-arrow-up" /> 0
      </span>
    );

  return (
    <span className="cf-uploads">
      <i
        className="fa-solid fa-cloud-arrow-up"
        data-tooltip-id="tooltip"
        data-tooltip-content={`${total} upload session${total > 1 ? "s" : ""}`}
      />
      {BUCKETS.map((bucket) => {
        const value = bucket.statuses.reduce(
          (acc, status) => acc + (counts[status] ?? 0),
          0
        );
        const clickable = Boolean(onSelect);
        const select = () => onSelect(bucket.label);
        return (
          <span
            key={bucket.key}
            className={"cf-uploads__dot" + (clickable ? " is-clickable" : "")}
            style={{ background: bucket.color }}
            onClick={clickable ? select : undefined}
            role={clickable ? "button" : undefined}
            tabIndex={clickable ? 0 : undefined}
            onKeyDown={
              clickable
                ? (event) => {
                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault();
                      select();
                    }
                  }
                : undefined
            }
            data-tooltip-id="tooltip"
            data-tooltip-content={`${bucket.label}: ${value}`}
          >
            {value}
          </span>
        );
      })}
    </span>
  );
};

UploadCounter.propTypes = {
  counts: PropTypes.object,
  onSelect: PropTypes.func,
};
